import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "resources"
    }}>{`Resources`}</h1>
    <p>{`The following document provides a list of resources for you to better understand how to use Mobile SDK.`}</p>
    <h2 {...{
      "id": "privacy-and-gdpr"
    }}>{`Privacy and GDPR`}</h2>
    <p>{`To learn how to manage consent and privacy obligations with Mobile SDK, please read the guide on `}<a parentName="p" {...{
        "href": "../privacy-and-gdpr.md"
      }}>{`privacy and GDPR`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      